import { useState } from "react";
import arrowDownIcon from "assets/icons/arrowDownIcon.svg";

const AppSelect = ({ options, label, onChange, open, className, value, style }) => {
    const [toggleSelect, setToggleSelect] = useState(open || false);

    return (
        <div className={`form-group ${className}`} >
            {label && <label>{label}</label>}
            <div className="select-wrapper" >
                <select name="type" value={value} onChange={onChange} style={style}>
                    {
                        options.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))
                    }

                </select>
            </div>
        </div>
    );
};

export default AppSelect;
